import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout = ({
  children
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-389">
      <Header data-id="element-390" />
      <main className="flex-grow" data-id="element-391">{children}</main>
      <Footer data-id="element-392" />
    </div>;
};